import { Alert, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "@context/ThemeContext";

export function TriageAlert() {
  const { t } = useTranslation();
  const { mode } = useThemeMode();

  return (
    <Alert
      icon={<InfoIcon />}
      severity="info"
      sx={{
        bgcolor:
          mode === "light"
            ? "rgba(30, 58, 138, 0.08)"
            : "rgba(182, 196, 255, 0.08)",
        border: "1px solid",
        borderColor:
          mode === "light"
            ? "rgba(30, 58, 138, 0.15)"
            : "rgba(182, 196, 255, 0.15)",
        "& .MuiAlert-icon": { color: "primary.main" },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 700,
          color: "text.primary",
        }}
      >
        {t("form.triageTitle")}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
        }}
      >
        {t("form.triageDescription")}
      </Typography>
    </Alert>
  );
}
